import fetch from 'isomorphic-fetch'
import _ from 'lodash'
import log from 'sentry/log'

import { actionCreators as authenticationActions } from '@blocket/authentication-fe'
import { handleApiResponse } from 'utils/api'
import isBrowser from 'utils/isBrowser'

// isomorphic-fetch does not provide a solution for max-retries or timeout
const MAX_RETRIES = 1
const { authentication } = authenticationActions

export const apiFetch = (url, params = {}, exclude401 = false, retryCount = 0) => async (
  dispatch,
  getState,
) => {
  let response

  try {
    response = await fetch(url, {
      ...params,
      headers: {
        'Content-Type': 'application/json; charset=utf8',
        ...params.headers,
        Authorization: `Bearer ${getState().authentication.bearerToken}`,
      },
    })
  } catch (fetchError) {
    /* eslint-disable no-console */
    if (process.env.NODE_ENV === 'development') {
      console.warn(`fetching ${url} failed, retrying once: ${fetchError}`)
    }

    try {
      response = await fetch(url, {
        ...params,
        headers: {
          'Content-Type': 'application/json; charset=utf8',
          ...params.headers,
          Authorization: `Bearer ${getState().authentication.bearerToken}`,
        },
      })
    } catch (retryFetchError) {
      if (process.env.NODE_ENV === 'development') {
        console.error(`fetching ${url} failed again: ${retryFetchError.message}`, retryFetchError)
      }
      retryFetchError.ok = false
      retryFetchError.status = 500
      retryFetchError.url = url

      throw retryFetchError
    }
  }

  if (response.status === 401 && !exclude401 && retryCount < MAX_RETRIES) {
    if (getState().authentication.loggedIn && isBrowser()) {
      log.message('spid bearer token is invalid while logged in.')
      dispatch(authentication.logout())
    }

    // Retry the fetch with a fresh apiKey bearerToken.
    await dispatch(authentication.fetchBearerToken('apiKey'))

    return dispatch(apiFetch(url, params, exclude401, retryCount + 1))
  }

  return handleApiResponse(response)
}

const amokApiFetch = (path, params) => (dispatch, getState) =>
  dispatch(apiFetch(`${getState().config.urls.api}/${path}`, params))

const templateApiFetch = (path, params) => (dispatch, getState) =>
  dispatch(apiFetch(`${getState().config.urls.api}/blocket/v7/template_proxy/${path}`, params))

const legacyApiFetch = (path, params) => (dispatch, getState) =>
  dispatch(
    apiFetch(
      `${getState().config.urls.api}/${path}`,
      _.merge({}, params, { headers: { 'X-Accept-Charset': 'utf-8' } }),
    ),
  )

const communicationApiFetch = (path, params, exclude401 = true) => (dispatch, getState) =>
  dispatch(apiFetch(`${getState().config.urls.api}/${path}`, params, exclude401))

export const actionCreators = {
  fetch: amokApiFetch,
  legacyApiFetch,
  templateApiFetch,
  communicationApiFetch,
}
